import { Controller } from 'stimulus'

// A plain GET to the workorders list: drops the closed-only status once upcoming
// ones are asked for, and the "all types" radio's empty value, which would filter.
export default class extends Controller {
  static targets = ['closedOnly']

  toggleUpcoming(event) {
    this.closedOnlyTarget.disabled = event.target.checked
  }

  submit() {
    this._radios().forEach(radio => { radio.disabled = radio.checked && radio.value === '' })

    // Only this modal closes, the list opening in a new tab; deferred until the browser has read the fields.
    setTimeout(() => {
      this._radios().forEach(radio => { radio.disabled = false })
      $(this.element.closest('.modal')).modal('hide')
    }, 0)
  }

  _radios() {
    return this.element.querySelectorAll('input[type="radio"]')
  }
}
